<div class="card-content">
  <div class="container">
      <div class="title">Impossible d'accéder au cabinet</div>
      <p class="info" *ngIf="type==='not-deployed'">Le cabinet est en cours de déploiement.</p>
      <p class="info" *ngIf="type==='disabled'">Le cabinet est désactivé.</p>
      <p class="info" *ngIf="type==='generic' || type===''">Un soucis lors de l'accès à votre profil/cabinet est survenue.</p>
      <p class="info" *ngIf="type==='maintenance'">L'application est en cours de maintenance</p>
      <br/>
      <div class="text">Si le problème persiste veuillez contacter le support</div>

      <div class="buttons-container">
        <div class="back-custom-container">
            <button type="submit" class="button back-custom" (click)="back()">
               Retour à la connexion
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>

  </div>
</div>
